import { Accordion } from "@mantine/core";

interface IProps {
  accordionValue: string[];
  setAccordionValue: React.Dispatch<React.SetStateAction<string[]>>;
  children: React.ReactNode;
}

export default function AccordionDescriptions({
  accordionValue,
  setAccordionValue,
  children,
}: IProps) {
  return (
    <Accordion
      multiple
      value={accordionValue}
      onChange={setAccordionValue}
      w="100%"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "32px",
      }}
      styles={{
        item: {
          borderBottom: `none !important`,
          boxShadow: "0 25px 35px rgba(0, 0, 0, 0.03) !important",
          borderRadius: "12px !important",
        },
        label: {
          display: "flex",
          alignItems: "center",
          gap: "16px",
          padding: "0",
        },
        control: {
          padding: "14px 16px",
        },
        chevron: {
          width: "24px",
          svg: {
            width: "24px",
            height: "24px",
          },
        },
      }}
    >
      {children}
    </Accordion>
  );
}
